import React, { useState } from 'react'
import styles from './SectionTop.module.css'
import groupImg from '../Asset_Products/OfficePackageImg.svg'
import CommonArrow from '../Asset_Products/ArrowCommon.svg'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import Modal from './Modal';
import ThankyouPopup from './ThankyouPopup'

const OfficePackagePolicyTop = () => {
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);

    const handleButtonClick = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    // State to manage form data
    // State to manage form data
    const initialFormData = {
        companyName: '',
        yourName: '',
        companyEmail: '',
        yourNumber: '', // Correct field name
        Heading: "Office Package Policy"
    };

    const initialErrors = {
        companyName: '',
        yourName: '',
        companyEmail: '',
        yourNumber: ''
    };

    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState(initialErrors);

    const handleHomeClick = () => {
        navigate('/'); // Navigate to the homepage
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle input for company name and your name
        if (name === 'companyName' || name === 'yourName') {
            // Restrict input to letters only and limit length to 20 characters
            const sanitizedValue = value.replace(/[^a-zA-Z ]/g, ''); // Allow only letters and spaces
            if (sanitizedValue.length <= 20) {
                setFormData({
                    ...formData,
                    [name]: sanitizedValue
                });
            }
        } else if (name === 'yourNumber') {
            // Handle only numeric input and restrict to 10 digits for phone number
            if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
                setFormData({
                    ...formData,
                    [name]: value
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }

        validateField(name, value);
    };


    const validateField = (name, value) => {
        let error = '';

        switch (name) {
            case 'companyName':
                if (!value) {
                    error = 'Company Name is required';
                } else if (value.length > 20) {
                    error = 'Company Name is too large';
                }
                break;
            case 'yourName':
                if (!value) {
                    error = 'Your Name is required';
                } else if (value.length > 20) {
                    error = 'Your Name is too large';
                }
                break;
            case 'companyEmail':
                if (!value) {
                    error = 'Email is required';
                } else if (!/\S+@\S+\.\S+/.test(value)) {
                    error = 'Email is invalid';
                } else if (value.length > 30) {
                    error = 'Email is too large';
                }
                break;
            case 'yourNumber':
                if (!value) {
                    error = 'Phone Number is required';
                } else if (!/^\d{10}$/.test(value)) {
                    error = 'Phone Number must be exactly 10 digits';
                }
                break;
            default:
        }

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: error
        }));
    };

    const validateForm = () => {
        let valid = true;
        let newErrors = { ...initialErrors };

        Object.keys(formData).forEach((field) => {
            validateField(field, formData[field]);
            if (errors[field]) {
                valid = false;
            }
        });

        return valid;
    };

    const handleFormSubmit = (e) => {
        e.preventDefault(); // Prevent the default form submission behavior

        if (validateForm()) {
            console.log('Form Data:', formData);
            axios.post('https://policyplanner.com/SME/sme-mails.php', formData)
                .then((response) => {
                    // alert(response.data);
                    setFormData(initialFormData);
                    setShowModal(true); // Show the modal on successful response
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };
    return (
        <div className={`${styles.topSectionContainer} ${styles.topSectionContainer_office}`}>
            <div className='container'>
                <div className={`row ${styles.MainRowBox}`}>
                    <div className={`${styles.topHeadings}col-md-5`}>
                        <span className={`${styles.topHeading1}`}> Home {'>'}<span onClick={handleHomeClick} > SME </span>{'>'} <span className={`label ${styles.FormHeading2}`}>Office Package Policy </span></span>
                        <div className={`${styles.imgArrow}`}>
                            <span className={`${styles.topSectionGroupHealthHeading}`}>Office Package Policy</span>
                            <img src={CommonArrow} className={`${styles.ArrowImage1}`} alt="" />
                        </div>                    </div>
                    <div className="col-md-6">
                        <div className={`${styles.CircleContainer} d-flex justify-content-around align-items-center`}>
                            <div className={`${styles.Officecircle}`}>
                                Protect Your Office with One Powerful Policy
                            </div>
                            <div className={`${styles.Officecircle}`}>
                                Your Office's Safety, Our Priority
                            </div>
                        </div>
                        <img className={`${styles.firstRowImage} ${styles.OfficePolicyImage}`} src={groupImg} alt="" />
                    </div>
                    <div className={`col-md-6 ${styles.FirstRow} ${styles.firstRow1}`}>
                        <div className={`${styles.FirstColumn}`}>
                            <form onSubmit={handleFormSubmit}>
                                <div className={`${styles.FirstRowBox}`}>
                                    <div className={`label ${styles.FormHeadings}`}>Company Name</div>
                                    <input className={`${styles.CommonInputGroup}`} type="text" placeholder="Enter your company name" name="companyName" onChange={handleInputChange} value={formData.companyName} />
                                    {errors.companyName && <div style={{ color: "red" }} className={styles.error}>{errors.companyName}</div>}
                                </div>
                                <div className={`${styles.FirstRowBox}`}>
                                    <div className={`label ${styles.FormHeadings}`}>Your Name</div>
                                    <input className={`${styles.CommonInputGroup}`} type="text" placeholder="Enter your name" name="yourName" onChange={handleInputChange} value={formData.yourName} />
                                    {errors.yourName && <div style={{ color: "red" }} className={styles.error}>{errors.yourName}</div>}
                                </div>
                                <div className={`${styles.FirstRowBox}`}>
                                    <div className={`row ${styles.secondRow}`}>
                                        <div className="cont1 col-md-6">
                                            <div className={`label ${styles.FormHeadings}`}>Work Email Address</div>
                                            <input className={`${styles.CommonInputGroup}`} type="text" placeholder="example@gmail.com" name="companyEmail" onChange={handleInputChange} value={formData.companyEmail} />
                                            {errors.companyEmail && <div style={{ color: "red" }} className={styles.error}>{errors.companyEmail}</div>}
                                        </div>
                                        <div className="cont1 col-md-6">
                                            <div className={`label ${styles.FormHeadings}`}>Phone Number</div>
                                            <input className={`${styles.CommonInputGroup}`} type="text" placeholder="+91 0000000000" name="yourNumber" onChange={handleInputChange} value={formData.yourNumber} />
                                            {errors.yourNumber && <div style={{ color: "red" }} className={styles.error}>{errors.yourNumber}</div>}
                                        </div>
                                        <div className={` ${styles.FirstSubmitBtn}col-md-10 text-center`}>
                                            <button className={`${styles.GetQuoteBtn}`} type="submit">Get Quote {'->'}</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <Modal show={showModal} onClose={handleCloseModal}>
                                <ThankyouPopup onClose={handleCloseModal} />
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default OfficePackagePolicyTop
